import type { RequestProductsMetadata } from 'src/redux/products/types';
import type { Facet } from '../types/Facet';
import type { SyncProductsQueryFromURLPayload } from '../types/ProductsQueryState';

export const getFacetChangeMetadata = (
  currentFacets: Facet[],
  nextActiveFacetValuesByKey: SyncProductsQueryFromURLPayload['activeFacetValuesByKey'],
): RequestProductsMetadata | undefined => {
  const changedOptions = currentFacets.flatMap((currentFacet) => {
    const nextActiveValues = new Set(nextActiveFacetValuesByKey[currentFacet.alias] ?? []);
    return currentFacet.options.flatMap((currentOption) => {
      const nextActive = nextActiveValues.has(currentOption.value);
      if (currentOption.active === nextActive) {
        return [];
      }
      return [
        {
          facetTitle: currentFacet.title,
          optionActive: nextActive,
          optionTitle: currentOption.title,
        },
      ];
    });
  });

  return changedOptions.length === 1 ? changedOptions[0] : undefined;
};
